"use client";

import { Grid } from "@forestsync/ui";
import { TokenCard } from "./TokenCard";
import { TokenSkeleton } from "../LoadingSkeletons";
import type { TokenListItem } from "@/types/glassroom";

type TokenGridProps = {
  tokens: TokenListItem[];
  showSkeletons?: boolean;
};

export function TokenGrid({ tokens, showSkeletons = false }: TokenGridProps) {
  return (
    <div className="w-full">
      <Grid gutter="md">
        {/* Existing tokens */}
        {tokens.map((token, index) => (
          <Grid.Col
            key={token.serialNumber}
            span={{ base: 12, sm: 6, lg: 4, xl: 3 }}
          >
            <div
              className="animate-in slide-in-from-bottom-5 fade-in duration-400 fill-mode-both"
              style={{
                animationDelay: `${index * 50}ms`,
              }}
            >
              <TokenCard token={token} />
            </div>
          </Grid.Col>
        ))}

        {/* Loading skeletons for new cards */}
        {showSkeletons && (
          <Grid.Col span={{ base: 12, sm: 6, lg: 4, xl: 3 }}>
            <TokenSkeleton count={8} />
          </Grid.Col>
        )}
      </Grid>
    </div>
  );
}
